module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f631.81195a98.svg";